export const SNIPPETS_BASE_URL = "https://snippet.meticulous.ai";
